
import {map} from 'rxjs/operators';
import * as moment from 'moment';
import _isArray from 'lodash-es/isArray';
import _map from 'lodash-es/map';
import _unset from 'lodash-es/unset';
import _find from 'lodash-es/find';
import _keys from 'lodash-es/keys';
import _isObject from 'lodash-es/isObject';
import _merge from 'lodash-es/merge';

// Angular
import {Injectable} from '@angular/core';

// Observable
import {Subject, Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class FormService {

    constructor(public http: HttpClient) {
    }

    public defaultValue: any = {};

    // Sources
    private formData = new Subject<any>();

    // Streams
    public formData$ = this.formData.asObservable();

    public setData(request: any, dontRemove?: string[]): void {
        this.formData.next(this.removeEmptyObjectsAndFormatDate(request, dontRemove));
    }

    /**
     * removeEmptyObjectsAndFormatDate Take the model, remove empty value and format date
     * Why don't you use map function ??
     * @param object : is the model
     * @param dontRemove : data to not remove even if empty
     */
    public removeEmptyObjectsAndFormatDate(object: object, dontRemove?: string[]): any {
        if (!dontRemove) {
            dontRemove = [];
        }
        Object.keys(object).forEach((key) => {
            // If Object recall function, keep in mind : Array is Object in JS
            if (object[key] && typeof object[key] === 'object') {
                // Recursion
                this.removeEmptyObjectsAndFormatDate(object[key], dontRemove);
                // Format date to YYYY-MM-DD
                if (object[key] instanceof Date || moment.isMoment(object[key])) {
                    object[key] = this.formatDate(object[key]);
                }

                // If object is empty then delete it
                if (!Object.keys(object[key]).length && dontRemove.indexOf(key) === -1) {
                    delete object[key];
                }
            }
            // If null delete property
            else if (
                (object[key] === null || object[key] === '' || object[key] === ' ') &&
                dontRemove && dontRemove.indexOf(key) === -1) {
                delete object[key];
            }
        });
        return object;
    }

    /**
     * Format date to attempted form YYYY-MM-DD
     * @param {Date} date  : Date format
     */
    private formatDate(date: Date) {
        return moment(date).format('YYYY-MM-DD');
    }

    private cleanData(_data: any): any {
        _map(_data, (_value: any, _key: string) => {
            if (_value instanceof Date) {
                _value = this.formatDate(_value);
            } else if ((_isObject(_value) && _value === {}) ||
                (_isArray(_value) && (_value.length === 0 || _value === [""])) ||
                !_value.length) {
                _unset(_data, _key);
            }
        });

        return _data;
    }

    public getDefault(_defaultUrl, _defaultAppUrl) {
        this.http.get(_defaultUrl)
            .subscribe((res: any) => {
                    this.defaultValue = res;
                    if (_defaultAppUrl) {

                        this.getAppDefault(_defaultAppUrl);
                    }
                },
                (error: Error): any => {
                //
                });
    }

    public getAppDefault(_defaultAppUrl): Observable<any> {
        return this.http.get(_defaultAppUrl).pipe(
            map((res: any) => {
                    this.defaultValue = _merge(this.defaultValue, res);

                    return this.defaultValue;
                },
                (error: Error): any => {
                //
                }));
    }
}
